// Locale-aware date & datetime formatters.
// EN → MM/DD/YYYY (US standard, primary Boston market)
// ES → DD/MM/YYYY (Latin America / Spain convention)

const localeMap = { en: "en-US", es: "es-ES" };

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  // ISO date-only strings (YYYY-MM-DD) need to be treated as local, otherwise the
  // browser interprets them as UTC midnight and shifts a day in negative TZs.
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDate(value, locale = "en") {
  const d = toDate(value);
  if (!d) return "—";
  return new Intl.DateTimeFormat(localeMap[locale] || "en-US", {
    month: "2-digit", day: "2-digit", year: "numeric",
  }).format(d);
}

export function formatDateTime(value, locale = "en") {
  const d = toDate(value);
  if (!d) return "—";
  return new Intl.DateTimeFormat(localeMap[locale] || "en-US", {
    month: "2-digit", day: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
    hour12: locale === "en",
  }).format(d);
}

export function formatTime(value, locale = "en") {
  const d = toDate(value);
  if (!d) return "—";
  return new Intl.DateTimeFormat(localeMap[locale] || "en-US", {
    hour: "2-digit", minute: "2-digit",
    hour12: locale === "en",
  }).format(d);
}

export function formatCurrency(amount, currency = "USD", locale = "en") {
  const n = Number(amount || 0);
  return new Intl.NumberFormat(localeMap[locale] || "en-US", {
    style: "currency", currency,
  }).format(n);
}
